import React, { Component } from 'react';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';
import AddUpdateSubsidiary from 'components/imports/AddUpdateSubsidiary';
import { openModal } from 'actions/modalActions';
import { removeSubsidiary } from 'actions/consolidationsActions';

// TODO: disable add or update sub if codes are not unique use groupCodesUnique from utils/stateToState
class ConsolidationsModal extends Component {
  render() {
    const subsidiaries = Object.entries(
      this.props.consolidations.subsidiariesById
    );
    return (
      <div className="ConsolidationsModal">
        <h2>Consolidations</h2>
        <div className="ConsolidationsList">
          <table>
            <thead>
              <tr>
                <th>Subsidiary name</th>
                <th>CF name</th>
                <th>Last updated</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {subsidiaries.map(([subId, sub], index) => (
                <tr key={`item-${index}`} index={index}>
                  <td className="name">{sub.name}</td>
                  <td className="filename">{sub.filename}</td>
                  <td className="updated">{sub.updated}</td>
                  <td>
                    <AddUpdateSubsidiary
                      openModal={this.props.openModal}
                      id={`updateSubsidiary-${subId}`}
                      subId={parseInt(subId, 10)}
                      subsidiary={sub}
                      label="↺"
                      title="Update subsidiary"
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn"
                      title="Remove subsidiary"
                      onClick={() => this.removeSubsidiary(parseInt(subId, 10))}
                    >
                      ×
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AddUpdateSubsidiary
          openModal={this.props.openModal}
          id="addSubsdiary"
          subsidiary={null}
          label="Add Subsidiary"
        />
      </div>
    );
  }

  removeSubsidiary = (subId) => {
    this.props.openModal({
      id: uuid(),
      type: 'confirmation',
      text: 'Are you sure you want to delete subsidiary?',
      onConfirm: () => {
        this.props.removeSubsidiary(subId);
      },
    });
  };
}

export default connect(
  // mapStateToProps
  (state, ownProps) => ({
    periodIds: state.accounts.periodIds,
    periodsById: state.accounts.periodsById,
    groups: state.groups,
    consolidations: state.consolidations,
  }),
  { openModal, removeSubsidiary }
)(ConsolidationsModal);
